import {useRoute, useRouter} from "vue-router";
import RouteSecurity from "@/router/RouteSecurity.ts";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";

/** Call first in the setup of a page whose route has meta.secured; returns false (after redirecting home) when the user may not open it. */
export const useRouteSecurityGuard = (): boolean => {
  const route = useRoute();
  if (RouteSecurity.canEnter(route))
    return true;
  useErrorsStore().pushErrorStr(RouteSecurity.missingCapabilityMessage(route));
  useRouter().replace("/");
  return false;
};
